export const environment = {
  production: true,
  baseUrl: (window as any).baseUrl,
  apiHost: `${(window as any).baseUrl}/api/v1`,
  apiUrl: `${(window as any).baseUrl}/api`,
  pageSize: 10,
  clientProjectsPageSize: 5,
  pusher_key: (window as any).PUSHER_KEY,
  minDeliveryDiscount: 0,
  maxDeliveryDiscount: 25,
  productPageSize: 12,
  googleApiKey:'AIzaSyAH_6iXEGGYEKcbGMhE9Q9ordTJqSkkfqU',
  APPLE_PAY_MERCHANT_ID:'merchant.com.teemapp.applepay',
  freeTrailDays: 30, // Days
  freeTrailStartDate: `2022-11-01`,
  newFreeTrailStartDate: `2025-01-01`,
  mixpanel_token:'8bc4dfe43e61f3baf1c385281b5fa122',
  clientId: '9c269a2a-9231-4fd6-994a-d822a0240753',
  foodicsUrl: 'https://console-sandbox.foodics.com',
  survicate_key:'4956d0124f17143e295f10fdb7453449',
  survey:{
    signup:'e745d2ce95226514',
    csat:'7e99e24960318e09',
    firstInvoice:'ae71fd64e468f74b',
    storefront:'ba015604bdd62af6'
  },
  firebaseConfig: {
    apiKey: "AIzaSyCSY9lluLOuOibFNkaPZCzzSTGEwDZEi0Y",
    authDomain: "teem-app-ec384.firebaseapp.com",
    projectId: "teem-app-ec384",
    storageBucket: "teem-app-ec384.firebasestorage.app",
    messagingSenderId: "218503734924",
    appId: "1:218503734924:web:83cd91dfc931b1eef57da9",
    measurementId: "G-EY218MDHV6",
    vapidKey: 'BDcrf_74FCA0wwaRBUHbnK7wVpwofs0AzgnarqIAEXeEFJth-WJYSZMKyN4mLpuYtX4iiGgIH6_F71BVQRsLvfE'
  }
};
